import React from 'react';
import * as _ from 'lodash';
import Helmet from 'react-helmet';

import {
  REQUEST_PARAMS, // API LIMIT
  HEADER_CONSTANTS, // ヘッダータイトル
} from '../utilities/constants';

import { EnterNameplatesSearchForm } from '../components/searchmenus/EnterNameplates';
import { EnterNameplatesContents } from '../components/tables/EnterNameplates';

const mock = {
  workers: [
    {
      partner_company_id: 1,
      name: '東栄鉄工株式会社',
      worker: [
        {
          user_id: 1,
          name: '福井 信平',
          kana: 'ふくい しんぺい',
        },
        {
          user_id: 2,
          name: '小笠原 孝彦',
          kana: 'おがさわら たかひこ',
        },
        {
          user_id: 3,
          name: '片山 玲一',
          kana: 'かたやま れいいち',
        },
        {
          user_id: 4,
          name: '浜口 彦好',
          kana: 'はまぐち ひこよし',
        },
        {
          user_id: 5,
          name: '岡崎 重三郎',
          kana: 'おかざき しげさぶろう',
        },
        {
          user_id: 6,
          name: '飯田 真理',
          kana: 'いい だまり',
        },
        {
          user_id: 7,
          name: '島田 奈緒',
          kana: 'しまだ なお',
        },
        {
          user_id: 8,
          name: '小野 慶介',
          kana: 'おの けいすけ',
        },
        {
          user_id: 9,
          name: '浜口 美津枝',
          kana: 'はまぐち みつえ',
        },
      ],
    },
    {
      partner_company_id: 2,
      name: '東海シティガード株式会社',
      worker: [
        {
          user_id: 10,
          name: '福井 信平',
          kana: 'ふくい しんぺい',
        },
        {
          user_id: 11,
          name: '小笠原 孝彦',
          kana: 'おがさわら たかひこ',
        },
        {
          user_id: 12,
          name: '片山 玲一',
          kana: 'かたやま れいいち',
        },
        {
          user_id: 13,
          name: '浜口 彦好',
          kana: 'はまぐち ひこよし',
        },
        {
          user_id: 14,
          name: '岡崎 重三郎',
          kana: 'おかざき しげさぶろう',
        },
        {
          user_id: 15,
          name: '飯田 真理',
          kana: 'いい だまり',
        },
        {
          user_id: 16,
          name: '島田 奈緒',
          kana: 'しまだ なお',
        },
        {
          user_id: 17,
          name: '小野 慶介',
          kana: 'おの けいすけ',
        },
        {
          user_id: 18,
          name: '浜口 美津枝',
          kana: 'はまぐち みつえ',
        },
      ],
    },
    {
      partner_company_id: 3,
      name: '東洋熱工業株式会社',
      worker: [
        {
          user_id: 20,
          name: '福井 信平',
          kana: 'ふくい しんぺい',
        },
        {
          user_id: 21,
          name: '小笠原 孝彦',
          kana: 'おがさわら たかひこ',
        },
        {
          user_id: 22,
          name: '片山 玲一',
          kana: 'かたやま れいいち',
        },
        {
          user_id: 23,
          name: '浜口 彦好',
          kana: 'はまぐち ひこよし',
        },
        {
          user_id: 24,
          name: '岡崎 重三郎',
          kana: 'おかざき しげさぶろう',
        },
        {
          user_id: 25,
          name: '飯田 真理',
          kana: 'いい だまり',
        },
        {
          user_id: 26,
          name: '島田 奈緒',
          kana: 'しまだ なお',
        },
        {
          user_id: 27,
          name: '小野 慶介',
          kana: 'おの けいすけ',
        },
        {
          user_id: 28,
          name: '浜口 美津枝',
          kana: 'はまぐち みつえ',
        },
      ],
    },
  ],
};

/**
 * 入退場管理 QRコード
 */
export class EnterNameplates extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldId: sessionStorage.getItem('field_id'), // 現場ID
      total: 0, // 作業員数
      loaded: false, // ロード完了フラグ
      isOpened: false, // 検索フォームの開閉フラグ
      workers: {}, // 一覧
      selectedList: {}, // 選択したIDを格納
      closedAll: false, // 開閉状態
      closedGroup: [], // グループの開閉状態
      selectedGroup: {}, // グループ単位で選択したのをboolで管理
      searchConditions: {
        // 検索条件
        company_name: '', // 協力会社
        worker_name: '', // 作業員
      },
    };

    this.events = {
      search: {
        handleOpen: this.handleFormOpen.bind(this), // 検索フォーム開閉イベント
        clear: this.clearConditions.bind(this), // 検索条件クリア
        set: this.setConditions.bind(this), // 検索条件セット
        gets: this.getsByConditions.bind(this), // 検索実行
      },
      table: {
        selectedRow: this.handleSelectedRow.bind(this), // 単一選択
        selectedAll: this.handleSelectedAll.bind(this), // 全選択
        toggleGroup: this.handleToggleGroup.bind(this), // グループ単位で開閉
        selectedGroup: this.handleSelectedGroup.bind(this), // グループ単位で選択
        seeMore: this.fetchCheckinouts.bind(this), // 10件取得
      },
    };

    this.isSelected = this.isSelected.bind(this); // 単一選択判定
    this.isClosedGroup = this.isClosedGroup.bind(this); // グループ開閉状態
    this.getCheckinouts = this.getCheckinouts.bind(this); // 入退場実績取得
    this.isSelectedGroup = this.isSelectedGroup.bind(this); // グループ選択済み判定
    this.checkSelectedList = this.checkSelectedList.bind(this); // 選択したデータがあるか判定
    this.handleToggleGroupAll = this.handleToggleGroupAll.bind(this); // 全開閉
  }

  componentDidMount() {
    this.getCheckinouts(() => {});
  }

  /**
   * 検索フォーム開閉
   */
  handleFormOpen = () => {
    this.setState({ isOpened: !this.state.isOpened });
  };

  /**
   * 検索条件クリア
   */
  clearConditions = () => {
    let state = this.state;
    state.searchConditions = {
      company_name: '', // 協力会社
      worker_name: '', // 作業員
    };
    this.setState(state);
  };

  /**
   * 検索条件セット
   */
  setConditions = (name, value) => {
    let state = this.state;
    state.searchConditions[name] = value;
    this.setState(state);
  };

  /**
   * ロード完了フラグを解除して再検索
   */
  getsByConditions = () => {
    let state = this.state;
    state.loaded = false;
    state.partnerCompanies = {};
    this.setState(state);
    this.getCheckinouts(() => {});
  };

  /**
   * 予定単一選択
   * @params partnerCompanyId {int}
   * @params selected {boolean} // 選択済み判定
   */
  handleSelectedRow = (e, partnerCompanyId, selected) => {
    let selectedList = this.state.selectedList;
    if (selected) {
      if (_.isEmpty(selectedList[partnerCompanyId])) {
        selectedList[partnerCompanyId] = [];
      }
      selectedList[partnerCompanyId].push(parseInt(e.target.value));
    } else {
      selectedList = {};
      let selectedGroup = this.state.selectedGroup;
      _.each(this.state.selectedList[partnerCompanyId], parterCompany => {
        if (parseInt(parterCompany) !== parseInt(e.target.value)) {
          if (_.isEmpty(selectedList[partnerCompanyId])) {
            selectedList[partnerCompanyId] = [];
          }
          selectedList[partnerCompanyId].push(parterCompany);
        }
      });
      selectedGroup[partnerCompanyId] = false;
      this.setState({ selectedGroup });
    }

    this.setState({ selectedList });
  };

  /**
   * 取得したデータ全選択
   * @params selected {boolean} 選択したかどうか判定
   */
  handleSelectedAll = selected => {
    let selectedList = {};
    let selectedGroup = {};
    if (selected) {
      _.each(this.state.workers, parterCompany => {
        selectedList[parterCompany.partner_company_id] = [];
        selectedGroup[parterCompany.partner_company_id] = true;
        _.each(parterCompany.worker, worker =>
          selectedList[parterCompany.partner_company_id].push(
            parseInt(worker.user_id)
          )
        );
      });
    }

    this.setState({
      selectedGroup,
      selectedList,
    });
  };

  /**
   * グループ単位開閉
   * @params closed {boolean} // 開閉判定
   * @params partnerCompanyId {int}
   */
  handleToggleGroup = (closed, partnerCompanyId) => {
    let closedGroup = this.state.closedGroup;
    if (closed) {
      closedGroup.push(parseInt(partnerCompanyId));
    } else {
      closedGroup = [];
      _.map(this.state.closedGroup, id => {
        if (id !== parseInt(partnerCompanyId)) {
          closedGroup.push(id);
        }
      });
    }

    this.setState({ closedGroup });
  };

  /**
   * グループ全開閉
   * @params closed {boolean} // 開閉判定
   */
  handleToggleGroupAll = () => {
    const open = !this.state.closedAll;
    let closedGroup = [];
    if (open) {
      _.map(this.state.workers, parterCompany =>
        closedGroup.push(parseInt(parterCompany.partner_company_id))
      );
    }

    this.setState({
      closedAll: open,
      closedGroup,
    });
  };

  /**
   * グループ単位で選択
   * @params checked {boolean} // 選択判定
   * @params partnerCompanyId {int}
   */
  handleSelectedGroup = (checked, partnerCompanyId) => {
    let selectedList = this.state.selectedList;
    let selectedGroup = this.state.selectedGroup;
    if (checked) {
      if (_.isEmpty(selectedList[partnerCompanyId])) {
        selectedList[partnerCompanyId] = [];
      }
      _.each(this.state.workers[partnerCompanyId].worker, worker => {
        selectedList[partnerCompanyId].push(parseInt(worker.user_id));
      });
      selectedGroup[partnerCompanyId] = true;
    } else {
      selectedList[partnerCompanyId] = [];
      selectedGroup[partnerCompanyId] = false;
    }

    this.setState({
      selectedGroup,
      selectedList,
    });
  };

  /**
   * 選択判定
   * @params partnerCompanyId {int}
   * @params userId {int}
   */
  isSelected(partnerCompanyId, userId) {
    let bool = false;
    if (
      _.indexOf(this.state.selectedList[partnerCompanyId], parseInt(userId)) !==
      -1
    ) {
      bool = true;
    }
    return bool;
  }

  /**
   * グループ単位の開閉判定
   * @params partnerCompanyId {int}
   * @return boolean
   */
  isClosedGroup(partnerCompanyId) {
    let bool = false;
    if (_.indexOf(this.state.closedGroup, parseInt(partnerCompanyId)) !== -1) {
      bool = true;
    }
    return bool;
  }

  /**
   * グループ単位の選択判定
   * @params partnerCompanyId {int}
   * @return boolean
   */
  isSelectedGroup(partnerCompanyId) {
    return this.state.selectedGroup[partnerCompanyId];
  }

  /**
   * データを選択しているかどうか判定
   * @return boolean
   */
  checkSelectedList() {
    let bool = true;
    // eslint-disable-next-line no-unused-vars
    _.each(this.state.selectedList, (selected, id) => {
      if (!_.isEmpty(selected)) {
        bool = false;
      }
    });
    return bool;
  }

  /**
   * 入退場実績取得
   */
  getCheckinouts(notify) {
    if (this.state.loaded) {
      notify();
      return;
    }

    // eslint-disable-next-line no-unused-vars
    let params = {
      limit: REQUEST_PARAMS.parentLimit,
      offset: _.size(this.state.workers),
    };

    params = _.merge(params, this.state.searchConditions);

    /*
    CheckinoutService.list(this.state.fieldId, params).then((response)=>{
      if(response.result){
      }
      notify();
    })
    */
    const data = mock.workers;
    if (_.isEmpty(data)) {
      this.setState({ loaded: true });
    } else {
      let workers = this.state.workers;
      _.each(data, entity => {
        workers[entity.partner_company_id] = entity;
        workers[entity.partner_company_id].workerLoaded =
          _.size(entity.worker) < REQUEST_PARAMS.childLimit ? true : false;
      });
      this.setState({
        loaded: false,
        workers,
      });
    }
  }

  /**
   * 追加取得
   * @params partnerCompanyId {int}
   */
  // eslint-disable-next-line no-unused-vars
  fetchCheckinouts(partnerCompanyId) {}

  render() {
    return (
      <div id='main' className='main'>
        <Helmet>
          <title>{HEADER_CONSTANTS.gatekeeper} - 入場者名札QRコード</title>
        </Helmet>
        <div className='main__header'>
          <h1>入場者名札QRコード</h1>
        </div>
        <div className='main__body'>
          <div className='gate-schedulelist'>
            <div className='gate-schedulelist__header'>
              <ul className='btn-menu'>
                <li className='btn-menu__item'>
                  <button id='open-slide-view' className='btn--sub'>
                    選択したデータを出力
                  </button>
                </li>
              </ul>
            </div>
            <EnterNameplatesSearchForm
              total={this.state.total}
              isOpened={this.state.isOpened}
              searchConditions={this.state.searchConditions}
              callbacks={this.events.search}
            />
            <div className='gate-schedulelist__list-header'>
              <ul className='btn-menu'>
                <li className='btn-menu__item'>
                  <button
                    id='btn-check-all'
                    className='btn--stay'
                    onClick={() => this.events.table.selectedAll(true)}
                  >
                    表示項目を全て選択
                  </button>
                </li>
                <li className='btn-menu__item'>
                  <button
                    id='btn-uncheck-all'
                    className='btn-text'
                    onClick={() => this.events.table.selectedAll(false)}
                  >
                    選択中の項目を解除
                  </button>
                </li>
              </ul>
            </div>
            <div className='gate-schedulelist__list'>
              <table className='table'>
                <thead className='table__header'>
                  <tr className='table__label'>
                    <td className='entrance-exit-table entrance-exit-table--table__label entrance-exit-table__open'>
                      <span className='entrance-exit-table__label'>開閉</span>
                      <button
                        className='btn-icon--xs--dark'
                        onClick={() => this.handleToggleGroupAll()}
                      >
                        <i
                          className={
                            this.state.closedAll
                              ? 'i-warrow-bottom i-2x'
                              : 'i-warrow-top i-2x'
                          }
                        />
                      </button>
                    </td>
                    <td />
                    <td
                      id='entrance-exit-table--date'
                      className='entrance-exit-table entrance-exit-table--table__label'
                    >
                      <div className='entrance-exit-table__label'>作業員ID</div>
                    </td>
                    <td
                      id='entrance-exit-table--id'
                      className='entrance-exit-table entrance-exit-table--table__label'
                    >
                      <div className='entrance-exit-table__label'>作業員名</div>
                    </td>
                    <td
                      id='entrance-exit-table--delivery-company'
                      className='entrance-exit-table entrance-exit-table--table__label'
                    >
                      <div className='entrance-exit-table__label'>ふりがな</div>
                    </td>
                    <td
                      id='entrance-exit-table--track'
                      className='entrance-exit-table entrance-exit-table--table__label'
                    >
                      <div className='entrance-exit-table__label'>
                        現場登録日
                      </div>
                    </td>
                    <td
                      id='entrance-exit-table--constructor'
                      className='entrance-exit-table entrance-exit-table--table__label'
                    >
                      <div className='entrance-exit-table__label'>
                        最終更新日
                      </div>
                    </td>
                    <td className='entrance-exit-table entrance-exit-table--table__label' />
                    <td className='entrance-exit-table__flex-auto' />
                  </tr>
                </thead>
                {_.map(this.state.workers, (data, index) => (
                  <EnterNameplatesContents
                    key={index}
                    closed={this.isClosedGroup(data.partner_company_id)}
                    parterCompany={data}
                    selectedGroup={this.isSelectedGroup(
                      data.partner_company_id
                    )}
                    isSelected={this.isSelected}
                    callbacks={this.events.table}
                  />
                ))}
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/EnterNameplates.jsx